import { useEffect } from "react";

/**
 * Sends data to the server before the page unloads (reload, tab close, etc.)
 * @param url API endpoint
 * @param getData Function that returns the data You want to send
 */
export function useUnloadBeacon(url: string, call: () => void) {
  useEffect(() => {
    const handleBeforeUnload = () => {
      navigator.sendBeacon(url, JSON.stringify(call()));
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [url, call]);
}
